export enum LogType {
    App = 'app',
    AppDelivery = 'app-delivery',
    AppBroadcast = 'app-broadcast',
    WebRTCBroadcast = 'webrtc-broadcast',
    WebRTCDelivery = 'webrtc-delivery'
}